var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:{ 'show' : _vm.getIsNotificationVisible }},[_vm._v(_vm._s(_vm.notificationtext))])}
var staticRenderFns = []

export { render, staticRenderFns }